export const CANVAS_ZOOM = 'canvas-zoom';
export const CANVAS_CLICK = 'canvas-click';
export class CanvasEvents {
    constructor() {
        this.debugger = null;
        this.listeners = {};
    }
    registerDebugger(canvasDebugger) {
        this.debugger = canvasDebugger;
    }
    subscribe(type, callback) {
        const listeners = this.listeners;
        if (!listeners[type]) {
            listeners[type] = [];
        }
        listeners[type].push(callback);
    }
    unsubscribe(callback) {
        const listeners = this.listeners;
        Object.values(listeners).forEach((callbacks) => {
            const index = callbacks.indexOf(callback);
            if (index > -1) {
                callbacks.splice(index, 1);
            }
        });
    }
    publish(type, args) {
        const canvasDebugger = this.debugger;
        const listeners = this.listeners[type];
        canvasDebugger === null || canvasDebugger === void 0 ? void 0 : canvasDebugger.debug('Events', `Event ${type}`, args);
        if (!listeners) {
            return;
        }
        listeners.forEach((callback) => callback(args));
    }
}
export default new CanvasEvents();
